import { render, staticRenderFns } from "./modal_newstrend_chart.vue?vue&type=template&id=4d4b1f6a&scoped=true"
import script from "./modal_newstrend_chart.vue?vue&type=script&lang=js"
export * from "./modal_newstrend_chart.vue?vue&type=script&lang=js"
import style0 from "./modal_newstrend_chart.vue?vue&type=style&index=0&id=4d4b1f6a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d4b1f6a",
  null
  
)

export default component.exports